<template>
  <div class>
    <div
      class
    >
      <!--@close="close()"-->
      <ModalBasic
        v-if="modal_show"
        :body="false"
      >
        <template v-slot:header>
          <h2 class="text-danger">
            <p v-if="!modal_show_error">
              Vielen Dank für Ihre Anfrage!
              <br>Ich werde mich in Kürze bei Ihnen melden.
            </p>
            <p
              v-if="modal_show_error"
            >
              Leider konnte Ihre Anfrage nicht abgeschickt werden, bitte schreiben Sie eine Mail an:
            </p>
          </h2>
        </template>

        <template v-slot:footer>
          <p />
        </template>
      </ModalBasic>

      <div style>
        <div class="form-group">
          <input
            v-model="email"
            type="email"
            class="form-control"
            placeholder="Ihre Email"
            :class="{ 'is-invalid': submitted && errors.indexOf('email') >= 0 }"
          >
          <input
            v-model="subject"
            type="text"
            class="form-control"
            placeholder="Betreff"
            :class="{ 'is-invalid': submitted && errors.indexOf('subject') >= 0 }"
          >
          <textarea
            v-model="message"
            placeholder="Ihre Nachricht"
            class="form-control"
            style="height: 300px;"
            :class="{ 'is-invalid': submitted && errors.indexOf('message') >= 0 }"
          />

          <div class="form-check">
            <input
              id="exampleCheck1"
              v-model="privacy"
              type="checkbox"
              class="form-check-input"
              name="privacy"
            >
            <label
              class="form-check-label"
              for="exampleCheck1"
            >Ich habe die Datenschutzrichtlinien zur Kenntnis genommen und willige in die darin beschriebene Verarbeitung meiner Daten ein.</label>
          </div>

          <p
            v-if="errors.length > 0"
            style=" color: red;"
          >
            Bitte füllen Sie alle Felder mit gültigten Texten aus
          </p>
          <p
            v-if="error_privacy"
            style=" color: red;"
          >
            Bitte stimmen Sie den
            <a>Datenschutzrichtlinien</a> zu.
          </p>
        </div>
        <button
          class="btn btn-primary btn-lg"
          @click="sendContact()"
        >
          Kontakt aufnehmen
        </button>
      </div>
    </div>
  </div>
  <!--End Form row-->
</template>

<script>
import ModalBasic from "@/components/ModalBasic.vue";
import axios from "axios";

export default {
  name: "Contact",
  components: {
    ModalBasic
  },
  data() {
    return {
      errors: [],
      submitted: false,
      email: "",
      subject: "",
      message: "",
      modal_show: false,
      modal_show_error: false,
      error_privacy: false,
      privacy: false
    };
  },
  methods: {
    sendContact() {
      this.submitted = true;

      this.errors = [];
      if (!this.email.match(/^\S+@\S+\.\S+$/)) {
        this.errors.push("email");
      }
      if (this.subject == "") {
        this.errors.push("subject");
      }
      if (this.message == "") {
        this.errors.push("message");
      }
      if (!this.privacy) {
        this.error_privacy = true;
      } else {
        this.error_privacy = false;
      }
      if (this.errors.length > 0 || this.error_privacy) {
        return;
      }
      var payload = {
        email: this.email,
        subject: this.subject,
        message: this.message
      };

      axios
        .post("https://api.gardsfabriken.de/api/v1/contact", payload)
        .then(() => {
          this.modal_show = true;
          this.email = "";
          this.subject = "";
          this.message = "";
          this.privacy = false;
          setTimeout(() => {
            this.modal_show = false;
          }, 2000);
        })
        .catch(e => {
          this.modal_show_error = true;
          this.modal_show = true;
          setTimeout(() => {
            this.modal_show = false;
            this.modal_show_error = false;
          }, 3000);
        });
    }
  }
};
</script>


<style lang="scss" scoped>
.is-invalid {
  border: 2px solid red;
}
</style>

